// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ChevronDown = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.059 6.073 12.76.371a.614.614 0 1 1 .868.868l-6.57 6.57-6.57-6.57a.612.612 0 0 1 0-.868c.24-.24.628-.24.867 0L7.06 6.073Z"
			fill="#C6C6C6"
		/>
	</svg>
);
export default ChevronDown;
